/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 绑定微信用户
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  wxBindDto: oauth2.WXBindDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oauth2/wx-user/binding`,
    data: wxBindDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
